// client/src/components/configuracoes/creditos/CreditosPacoteForm.js
import React, { useState, useEffect } from 'react';
import { Save, XCircle, Loader2 } from 'lucide-react';
import { useMutatePacoteCredito } from '../../../hooks/useComunicacaoCredito';

const CreditosPacoteForm = ({ current, onCloseForm }) => {
    const { criarPacote, atualizarPacote } = useMutatePacoteCredito();
    const isMutating = criarPacote.isPending || atualizarPacote.isPending;

    const [form, setForm] = useState({ nome: '', quantidadeCreditos: '', precoReais: '', ativo: true, ordem: 0 });

    useEffect(() => {
        if (current) {
            setForm({
                nome: current.nome || '',
                quantidadeCreditos: current.quantidadeCreditos || '',
                precoReais: current.preco ? (current.preco / 100).toFixed(2) : '',
                ativo: current.ativo !== undefined ? current.ativo : true,
                ordem: current.ordem || 0
            });
        }
    }, [current]);

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const onSubmit = (e) => {
        e.preventDefault();

        const payload = {
            nome: form.nome,
            quantidadeCreditos: parseInt(form.quantidadeCreditos, 10),
            preco: Math.round(parseFloat(String(form.precoReais).replace(',', '.')) * 100),
            ativo: form.ativo,
            ordem: parseInt(form.ordem, 10) || 0
        };

        if (current) {
            atualizarPacote.mutate({ id: current._id, ...payload }, { onSuccess: onCloseForm });
        } else {
            criarPacote.mutate(payload, { onSuccess: onCloseForm });
        }
    };

    return (
        <form onSubmit={onSubmit}>
            <div className="form-section">
                <h4 className="form-section-title">{current ? 'Editar Pacote' : 'Novo Pacote de Créditos'}</h4>
                <div className="form-grid-container-cols-2">
                    <div className="form-group">
                        <label className="form-label required">Nome</label>
                        <input name="nome" value={form.nome} onChange={onChange} className="form-input" placeholder="Ex.: Pacote 100 créditos" required />
                    </div>
                    <div className="form-group">
                        <label className="form-label required">Quantidade de Créditos</label>
                        <input type="number" name="quantidadeCreditos" min="1" value={form.quantidadeCreditos} onChange={onChange} className="form-input" required />
                    </div>
                    <div className="form-group">
                        <label className="form-label required">Preço (R$)</label>
                        <input type="text" name="precoReais" value={form.precoReais} onChange={onChange} className="form-input" placeholder="Ex.: 50,00" required />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Ordem de Exibição</label>
                        <input type="number" name="ordem" value={form.ordem} onChange={onChange} className="form-input" />
                    </div>
                    <div className="form-group-checkbox">
                        <input type="checkbox" name="ativo" id="ativo" checked={form.ativo} onChange={onChange} className="form-checkbox" />
                        <label htmlFor="ativo">Pacote ativo (visível pra compra)</label>
                    </div>
                </div>
            </div>

            <div className="form-actions">
                <button type="button" onClick={onCloseForm} className="action-button action-button-secondary">
                    <XCircle size={18} className="icon" />Cancelar
                </button>
                <button type="submit" disabled={isMutating} className="action-button action-button-primary">
                    {isMutating ? <Loader2 size={18} className="icon animate-spin" /> : <Save size={18} className="icon" />}
                    {current ? 'Atualizar' : 'Criar Pacote'}
                </button>
            </div>
        </form>
    );
};

export default CreditosPacoteForm;
